module.exports = __webpack_public_path__ + "images/bannerES-f65d3274f4f7e27794a72e611f1a914f.jpg";